import { Mail, Building2, Briefcase, CalendarDays, User } from 'lucide-react';
import { formatDate } from '@/lib/formatters';
import type { AuthUser } from '@/types';
import { ROLE_LABELS, todayFormatted } from '../_labels';

export function WelcomeCard({
  profile,
  companyName,
}: {
  profile?: AuthUser;
  companyName?: string | null;
}) {
  return (
    <div className="rounded-xl border border-border bg-card p-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold text-card-foreground">
            Bienvenido, {profile?.first_name ?? 'Colaborador'}
          </h1>
          <p className="mt-1 text-sm capitalize text-muted-foreground">{todayFormatted()}</p>
        </div>
        <div className="flex items-center gap-2 rounded-lg bg-primary/10 px-3 py-1.5">
          <User className="h-4 w-4 text-primary" />
          <span className="text-sm font-medium text-primary">
            {[
              ...new Set(
                (profile?.roles ?? (profile?.role ? [profile.role] : [])).map(
                  (r) => ROLE_LABELS[r] ?? r,
                ),
              ),
            ].join(' · ') || profile?.role}
          </span>
        </div>
      </div>

      {/* Personal info grid */}
      <div className="mt-4 grid grid-cols-1 gap-3 border-t border-border pt-4 sm:grid-cols-2 lg:grid-cols-4">
        <div className="flex items-center gap-2.5">
          <Mail className="h-4 w-4 text-muted-foreground" />
          <div className="min-w-0">
            <p className="text-xs text-muted-foreground">Correo</p>
            <p className="truncate text-sm font-medium text-foreground">{profile?.email}</p>
          </div>
        </div>
        {companyName && (
          <div className="flex items-center gap-2.5">
            <Building2 className="h-4 w-4 text-muted-foreground" />
            <div className="min-w-0">
              <p className="text-xs text-muted-foreground">Empresa</p>
              <p className="truncate text-sm font-medium text-foreground">{companyName}</p>
            </div>
          </div>
        )}
        {profile?.user_positions && profile.user_positions.length > 0 && (
          <div className="flex items-center gap-2.5">
            <Briefcase className="h-4 w-4 text-muted-foreground" />
            <div className="min-w-0">
              <p className="text-xs text-muted-foreground">
                {profile.user_positions.length > 1 ? 'Puestos' : 'Puesto'}
              </p>
              <p className="truncate text-sm font-medium text-foreground">
                {profile.user_positions.map((up) => up.position.name).join(', ')}
              </p>
            </div>
          </div>
        )}
        {profile?.hired_at && (
          <div className="flex items-center gap-2.5">
            <CalendarDays className="h-4 w-4 text-muted-foreground" />
            <div className="min-w-0">
              <p className="text-xs text-muted-foreground">Fecha de ingreso</p>
              <p className="text-sm font-medium text-foreground">{formatDate(profile.hired_at)}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
